import type { Component } from 'solid-js'
import { AgentSettings } from './AgentSettings'

interface AdvancedIdentitySetupProps {
	params?: string[]
}

export const AdvancedIdentitySetup: Component<AdvancedIdentitySetupProps> = (props) => {
	return (
		<div flex='~ col' gap='4' p='4'>
			<AgentSettings />
		</div>
	)
}
